/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Training_Plan_CrumbInputs */

const en_training_plan_crumb = /** @type {(inputs: Training_Plan_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training plan`)
};

const pl_training_plan_crumb = /** @type {(inputs: Training_Plan_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan treningowy`)
};

/**
* | output |
* | --- |
* | "Training plan" |
*
* @param {Training_Plan_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const training_plan_crumb = /** @type {((inputs?: Training_Plan_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Training_Plan_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_training_plan_crumb(inputs)
	return en_training_plan_crumb(inputs)
});